// extracted by mini-css-extract-plugin
module.exports = {"searchinput":"SearchBox-module--searchinput--36Dfz","searchbutton":"SearchBox-module--searchbutton--3yU02"};